
const EmojiTitle = ({emojiReady, emojiKey, title}) => {
  return (
    <div className='flex align-items-middle'>
      {emojiReady && <div className='flex mr1'>
        <em-emoji className='emoji-icon' id={emojiKey} set='native' size='22px'></em-emoji>
      </div>}
      {title}
    </div>
  );
};

export default EmojiTitle;
